const GridElementModel = {
  elements: [],
};

export default GridElementModel;
